document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 9000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    var swiperUvp = new Swiper(".swiperUvp", {
        slidesPerView: 1,
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 9000,
            disableOnInteraction: false
        }
    });

    var swiperSlider = new Swiper(".swiperSlider", {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-slider",
            prevEl: ".swiper-button-prev-slider",
        },
        breakpoints: {
            320: {
                autoHeight: true,
            }
        }
    });

    var swiperSliderTimeline = new Swiper(".swiperSliderTimeline", {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-timeline",
            prevEl: ".swiper-button-prev-timeline",
        },
        breakpoints: {
            320: {
                autoHeight: true,
            },
            640: {
                autoHeight: false,
            }
        }
    });

    var swiperMenu = new Swiper(".swiperMenu", {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-menu",
            prevEl: ".swiper-button-prev-menu",
        },
        breakpoints: {
            320: {
                autoHeight: true,
            }
        }
    });

    var swiperAcommodations = new Swiper(".images-sliders", {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-button-next-accommodations",
        },
        breakpoints: {
            320: {
                autoHeight: true,
            }
        }
    });

    var swiperReviews = new Swiper(".swiperReviews", {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-reviews",
            prevEl: ".swiper-button-prev-reviews",
        },
        breakpoints: {
            320: {
                autoHeight: true,
            }
        }
    });

    var swiperAwards = new Swiper(".swiperAwards", {
        slidesPerView: 3,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-awards",
            prevEl: ".swiper-button-prev-awards",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                autoHeight: true,
            },
            768: {
                slidesPerView: 3,
                autoHeight: true,
            }
        }
    });

    var swiperVenues = new Swiper(".swiperVenues", {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next-venues",
            prevEl: ".swiper-button-prev-venues",
        }
    });

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });
});